<template>
  <BasicInfoCardComponent
    class="mt-4"
    :icon="'circle-info'"
    :titleText="$t('setPriceTerms.howMinimumPriceWorks')"
  >
    <p class="mt-3 mb-2 fs-8 lh-lg">
      {{ $t("setPriceTerms.contentParagraph1") }}
    </p>
    <p class="mt-3 mb-2 fs-8 lh-lg">
      {{ $t("setPriceTerms.content_paragraph_2") }}
    </p>
    <p class="mt-3 mb-2 fs-8 lh-lg">
      {{
        $t("setPriceTerms.content_paragraph_3", { duration: durationMonths })
      }}
    </p>
  </BasicInfoCardComponent>
</template>

<script setup lang="ts">
import BasicInfoCardComponent from "@/components/common/BasicInfoCardComponent.vue";
import { useCompanySpotStrategy } from "@/composables/useCompanySpotStrategy";
import { computed } from "vue";

const currentStrategy = useCompanySpotStrategy();
const durationMonths = computed(
  () => currentStrategy.value.durationMonths ?? 6
);
</script>
